import React from "react";
import { useRequestFormViewHook } from "./request-form-view-hooks";

type ContextRequestFormView = ReturnType<typeof useRequestFormViewHook>;
export const RequestFormViewContext =
  React.createContext<ContextRequestFormView | null>(null);

export function useContextRequestFormView() {
  const context = React.useContext(RequestFormViewContext);

  if (!context) {
    throw new Error(
      "useContextRequestFormView must be used within a ContextRequestFormViewProvider",
    );
  }

  return context;
}
